import { render, staticRenderFns } from "./ChooseLocationMulti.vue?vue&type=template&id=cb52af18&scoped=true"
import script from "./ChooseLocationMulti.vue?vue&type=script&lang=js"
export * from "./ChooseLocationMulti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb52af18",
  null
  
)

export default component.exports